import React from 'react'

import { FormattedMessage } from 'react-intl'

import InfluencerIdentityRowLabelTooltip from '@components/InfluencerIdentity/Row/LabelTooltip'
import InfluencerIdentityRowValueAndLabel from '@components/InfluencerIdentity/Row/ValueAndLabel'
import { SubmissionChannels } from '@enums'

interface IPerformanceAverageReachPercentProps {
  averageReach: number
  provider: SubmissionChannels
}

const BrandFanInfluencerIdentityRowPerformanceAverageReachPercent: React.FC<
  IPerformanceAverageReachPercentProps
> = ({ averageReach, provider }) => {
  const tooltip = `brandFans.analytics.avgReachPct.${provider}`

  return (
    <InfluencerIdentityRowValueAndLabel
      value={
        averageReach ? (
          <FormattedMessage id="core.text.percent" values={{ value: averageReach }} />
        ) : (
          <FormattedMessage
            id={
              [
                SubmissionChannels.Instagram,
                SubmissionChannels.Pinterest,
                SubmissionChannels.YouTube,
              ].includes(provider)
                ? 'core.metric.empty'
                : 'core.metric.na'
            }
          />
        )
      }
      label={
        <InfluencerIdentityRowLabelTooltip
          title={<FormattedMessage id="submission.prePurchaseAnalytics.post.avgReachPercentage" />}
          body={<FormattedMessage id={tooltip} />}
        >
          <FormattedMessage id="core.text.avgReachPercent" />
        </InfluencerIdentityRowLabelTooltip>
      }
      width={5.75}
    />
  )
}

export {
  BrandFanInfluencerIdentityRowPerformanceAverageReachPercent,
  type IPerformanceAverageReachPercentProps,
}
export default BrandFanInfluencerIdentityRowPerformanceAverageReachPercent
